import { z } from "zod";
import { stagingDiversionShape } from "../../../SystemSettingsStagingDiversion/SystemSettingsStagingDiversion.types";

/** Mirrors backend `DataprocStagingEntry` in system_settings_models.py. */
export const dataprocStagingSchema = z.object({
  project_id: z.string().catch(""),
  run_as_service_account: z.string().catch(""),
  service_account_key: z.string().nullable().catch(null),
  ...stagingDiversionShape,
  enabled: z.boolean().catch(true),
});

export type DataprocStagingEntry = z.infer<typeof dataprocStagingSchema>;

const EMPTY_ENTRY = dataprocStagingSchema.parse({});

export const parseDataprocStagingIntegrations = (
  raw: unknown
): DataprocStagingEntry[] =>
  z.array(dataprocStagingSchema.catch(EMPTY_ENTRY)).catch([]).parse(raw);
